export const GET_CUSTOMER_PROFILE = 'CUSTOMER_PROFILE';
export const RESET_CUSTOMER_PASSWORD_REQUEST = 'RESET_CUSTOMER_PASSWORD_REQUEST';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CUSTOMER_SIGNUP = 'CUSTOMER_SIGNUP';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGOUT = 'LOGOUT';


